import React from 'react';
import { ERegistrationStep, ProgressStepsState } from 'src/enums/ERegistrationSteps';
import { PROGRESS_STEP_MESSAGES, PROGRESS_STEP_STYLES } from 'src/constants/registrationConstants';

interface SandboxerProgressIndicatorProps {
	progressSteps: ProgressStepsState;
}

const SandboxerProgressIndicator: React.FC<SandboxerProgressIndicatorProps> = ({
	progressSteps,
}) => {
	const renderProgressStep = (step: ERegistrationStep) => {
		const status = progressSteps[step];
		const message = PROGRESS_STEP_MESSAGES[step][status];
		const dotStyle = PROGRESS_STEP_STYLES.dot[status];
		const textStyle = PROGRESS_STEP_STYLES.text[status];

		return (
			<div key={step} className="flex items-center gap-3">
				<div className={`w-2 h-2 rounded-full ${dotStyle}`} />
				<span className={`text-sm ${textStyle}`}>{message}</span>
			</div>
		);
	};

	return (
		<div className="space-y-3 text-left">
			{renderProgressStep(ERegistrationStep.USER)}
			{renderProgressStep(ERegistrationStep.BUSINESS)}
			{renderProgressStep(ERegistrationStep.CONFIGURING)}
			{renderProgressStep(ERegistrationStep.FINALIZING)}
		</div>
	);
};

export default SandboxerProgressIndicator;
